import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { Handle, Position } from '@xyflow/react'
import classNames from 'classnames'
import { Icon } from 'shared/ui'
import { FlowActionDropdown } from 'widgets/Flow'
import { useSmartCallFlowBuilderContext } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/context'
import { AddActionDropdownContent } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/CustomEdge/AddActionDropdownContent/AddActionDropdownContent'
import { type ISmartCallNodeProps } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/SmartCallFlowBuilderUi'
import styles from './styles.module.scss'

export const AddButtonNode = observer(({ id, viewOnly, disabled }: ISmartCallNodeProps) => {
  const [open, setOpen] = useState(false)
  const { getActionById } = useSmartCallFlowBuilderContext()
  const store = getActionById(id)

  if (viewOnly || !store) return null

  const parentId = store.actionStore.parentId
  const allowedActions = store.actionStore.allowedNextActions ?? []

  return (
    <>
      <Handle
        type='target'
        position={Position.Top}
        style={{ background: 'transparent', border: 'none', outline: 'none' }}
      />
      <div className={styles.wrap}>
        <button
          className={classNames(styles.button, { [styles.active]: open }, 'nodrag nopan')}
          onClick={() => setOpen((v) => !v)}
          disabled={disabled}
        >
          <Icon icon={'plusTrigger'} fontSize={10} />
        </button>
        {open && (
          <FlowActionDropdown setOpen={setOpen} transform='translate(-50%, 12px)' width={231}>
            <AddActionDropdownContent
              setOpen={setOpen}
              actions={allowedActions}
              target={id}
              source={parentId}
            />
          </FlowActionDropdown>
        )}
      </div>
    </>
  )
})
